import { useState } from "react";

const useSalesAccountSettings = (findAccountMapping) => {
  const [salesAccountMapping, setSalesAccountMapping] = useState({
    sales_account: findAccountMapping("sales_account")?.chart_account?.id || "",
    sales_return_account:
      findAccountMapping("sales_return_account")?.chart_account?.id || "",
    discount_given_account:
      findAccountMapping("discount_given_account")?.chart_account?.id || "",
    cash_bank_payment_method_account:
      findAccountMapping("cash_bank_payment_method_account")?.chart_account
        ?.id || "",
    cash_payment_method_account:
      findAccountMapping("cash_payment_method_account")?.chart_account?.id ||
      "",
    card_payment_method_account:
      findAccountMapping("card_payment_method_account")?.chart_account?.id ||
      "",
    transfer_payment_method_account:
      findAccountMapping("transfer_payment_method_account")?.chart_account
        ?.id || "",
    sales_delivery_fee_account:
      findAccountMapping("sales_delivery_fee_account")?.chart_account?.id || "",
    customer_credit_account:
      findAccountMapping("customer_credit_account")?.chart_account?.id || "",
    customer_store_wallet_account:
      findAccountMapping("customer_store_wallet_account")?.chart_account?.id ||
      "",
    customer_loyalty_and_gift_account:
      findAccountMapping("customer_loyalty_and_gift_account")?.chart_account
        ?.id || "",
    others_income_account:
      findAccountMapping("others_income_account")?.chart_account?.id || "",
  });

  return {
    salesAccountMapping,
    setSalesAccountMapping,
  };
};

export default useSalesAccountSettings;
